<template>
  <div
    class="ai-icon-background"
    :style="`
      width: ${width};
      height: ${width};
      padding: calc(${width} * 0.13);
      border-radius: calc(${width} * 0.07);
      `"
  >
    <div class="ai-icon-wrapper">
      <div
        :class="`ai-icon-beam ai-icon-beam-1 ${animation?'ai-icon-beam-1-animation':''}`"
        :style="color?`background-color: ${color}`:''"
        />
      <div
        :class="`ai-icon-beam ai-icon-beam-2 ${animation?'ai-icon-beam-2-animation':''}`"
        :style="color?`background-color: ${color}`:''"
        />
      <div
        :class="`ai-icon-beam ai-icon-beam-3 ${animation?'ai-icon-beam-3-animation':''}`"
        :style="color?`background-color: ${color}`:''"
        />
    </div>
  </div>
</template>
<script>
  export default {
    props: ['width', 'animation', 'color']
  }
</script>
<style>
  .ai-icon-background {
    position: relative;
    /* background: rgb(66,152,184);
      background: radial-gradient(
        circle, rgba(66,152,184,1) 0%,
        rgba(49,119,156,1) 0%,
        rgba(36,93,128,1) 36%,
        rgba(22,60,89,1) 59%,
        rgba(13,42,68,1) 73%,
        rgba(6,27,48,1) 90%,
        rgba(4,19,37,1) 100%); */
    transition: all ease-in-out 0.2s
  }
  .ai-icon-wrapper {
    position: relative;
    display: flex;
    height: 100%;
    width: 100%;
    overflow: hidden;

  }
  .ai-icon-beam {
    width: 12%;
    background-color: white;
    /* background-color: rgb(209, 243, 247); */
    /* box-shadow: 0px 0px 20px 0px white; */
  }
  .ai-icon-beam-1 {
    height: 120%;
    position: absolute;
    transform-origin: 0% 100%;
    transform: rotate(20deg);
    align-self: flex-end;
  }
  .ai-icon-beam-1-animation {
    animation-duration: 3.5s;
    animation-name: beamgrow1;
    animation-iteration-count: infinite;
  }
  .ai-icon-beam-2 {
    height: 120%;
    position: absolute;
    left: 40%;
    transform-origin: 0% 0%;
    transform: rotate(340deg);
    align-self: flex-start;
  }
  .ai-icon-beam-2-animation {
    animation-duration: 3.5s;
    animation-name: beamgrow2;
    animation-iteration-count: infinite;
  }
  .ai-icon-beam-3 {
    height: 120%;
    position: absolute;
    right: 5%;
    align-self: flex-end;
  }
  .ai-icon-beam-3-animation {
    animation-duration: 3.5s;
    animation-name: beamgrow3;
    animation-iteration-count: infinite;
  }
  /* Animation */
  @keyframes beamgrow1 {
  from {
    height: 0%;
  }
  25% {
    height: 120%;
  }
  to {
    height: 120%;
  }
  }
  @keyframes beamgrow2 {
  from {
    height: 0%;
  }
  25% {
    height: 0%;
  }
  50% {
    height: 120%;
  }
  to {
    height: 120%;
  }
  }
  @keyframes beamgrow3 {
  from {
    height: 0%;
  }
  25% {
    height: 0%;
  }
  50% {
    height: 0%;
  }
  75% {
    height: 120%;
  }
  to {
    height: 120%;
  }
  }

</style>
